import { decimalNumber } from "Utils/validationUtils";
import { VITE_isIE } from 'Constants/appEnvConstants';

const __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__ = ['initiate pre-compliance'];
const __FILE_COMPLIANCE_STAGE_CONFIG__ = ['file compliance'];
const __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__ = ['create good faith request'];
const __FILE_ARBITRATION_STAGE_CONFIG__ = ['file arbitration'];
const __FILE_INCOMING_ARBITRATION_STAGE_CONFIG__ = ['file incoming arbitration'];
const __FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__ = ['file outgoing arbitration'];

export function getActionPaneData() {
  return [
    {
      id: 1,
      width: '678px',
      title: 'Respond To Issuer:',
      seqNo: 0,
      description: 'Adjust Financials',
      viewCode: 'RTI',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 2,
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 700,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Representment Amount',
          description: 'Representment Amount',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '350px' : '325px',
          isRequired: true,
          currencyCodeDisabled: true, 
          marginTop: '20px',
          marginLeft: '0px',
          disabled: true,
          isCurrencyLabel: true,
          stage: ['Chargeback'],//US182222
        }, {
          name: 'Representment Reason',
          description: 'Representment Reason',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback'],//US182222
        },
        {
          name: 'Select Response to Pre-arbitration Inquiry',
          description: 'Select Response to Pre-arbitration Inquiry',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration'],//US182222
        },
        {
          name: 'Select Response to Arbitration Request',
          description: 'Select Response to Arbitration Request',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],//US182222
        },
        {
          name: 'Explanation to Issuer',
          description: 'Explanation to Issuer',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          stage: ['Chargeback', 'Incoming Pre-Arbitration', 'Incoming Arbitration'],//US182222
        },
        {
          name: 'Description',
          description: 'Description',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Retrieval Request'],//US182222
        },
        {
          name: 'Explanation to Issuer (optional)',
          description: 'Explanation to Issuer (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: false,
          stage: ['Retrieval Request'],//US182222 Not given in sheet but it should be
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },
      ],
    },

    {
      id: 4,
      title: 'Respond To Issuer:',
      description: 'Merchant Message',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant','merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 6,
      title: 'Respond To Issuer:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to issuer',
          description: 'Send Documents to Issuer',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
    {
      id: 7,
      description: 'Close Case',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      nextStepPerformSubmit: false,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      disabled: true,
      dataColumns: [
        {
          description: 'Display',
          name: 'Display',
          displayType: 'DROPDOWN',
          columnKey: 'noteType',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: false,
        },
      ],
    },
    {
      id: 8,
      description: 'Add Case Notes',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      reviewScreenKey: 'addNote',
      showCharCount: true,
      textAreaMaxLength: 999,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '4%' : '5%',
          'margin-top': '49px',
          wrapperButtonStyle: {
            'margin-left': '348px',
            'margin-top': '-1',
          },
        },
        {
          description: 'Notes',
          name: 'Notes',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },

    {
      id: 10,
      description: 'Pend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      showCharCount: true,
      reviewScreenKey: 'pendCase',
      textAreaMaxLength: 2000,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLISTPEND',
          columnKey: 'noteType',
          left: '14%',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: '',
          name: 'Reason for Pend',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },
    {
      id: 11,
      description: 'UnPend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      showCharCount: true,
      reviewScreenKey: 'unpendCase',
      textAreaMaxLength: 999,
    },
  ];
}
export function getProsaActionPaneData() {
  return [
    {
      id: 1,
      width: '678px',
      title: 'Respond To Issuer:',
      seqNo: 0,
      description: 'Adjust Financials',
      viewCode: 'RTI',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 2,
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 50,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Representment Amount',
          description: 'Representment Amount',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '350px' : '325px',
          isRequired: true,
          currencyCodeDisabled: true,
          marginTop: '20px',
          marginLeft: '0px',
          disabled: true,
          isCurrencyLabel: true,
          stage: ['Chargeback'],//US182222
        }, {
          name: 'Representment Reason',
          description: 'Representment Reason',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback'],//US182222
        },
        {
          name: 'Select Response to Pre-arbitration Inquiry',
          description: 'Select Response to Pre-arbitration Inquiry',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration'],//US182222
        },
        {
          name: 'Select Response to Arbitration Request',
          description: 'Select Response to Arbitration Request',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],//US182222
        },
        {
          name: 'Explanation to Issuer',
          description: 'Explanation to Issuer',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          regex:'^[A-Za-z0-9 .]+$',
          stage: ['Chargeback', 'Incoming Pre-Arbitration', 'Incoming Arbitration'],//US182222
        },
        {
          name: 'Description',
          description: 'Description',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Retrieval Request'],//US182222
        },
        {
          name: 'Explanation to Issuer (optional)',
          description: 'Explanation to Issuer (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: false,
          stage: ['Retrieval Request'],//US182222 Not given in sheet but it should be
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },

      ],
    },

    {
      id: 4,
      title: 'Respond To Issuer:',
      description: 'Merchant Message',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 6,
      title: 'Respond To Issuer:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to issuer',
          description: 'Send Documents to Issuer',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
    {
      id: 7,
      description: 'Close Case',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      nextStepPerformSubmit: false,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      disabled: true,
      dataColumns: [
        {
          description: 'Display',
          name: 'Display',
          displayType: 'DROPDOWN',
          columnKey: 'noteType',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: false,
        },
      ],
    },
    {
      id: 8,
      description: 'Add Case Notes',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      reviewScreenKey: 'addNote',
      showCharCount: true,
      textAreaMaxLength: 999,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '4%' : '5%',
          'margin-top': '49px',
          wrapperButtonStyle: {
            'margin-left': '348px',
            'margin-top': '-1',
          },
        },
        {
          description: 'Notes',
          name: 'Notes',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },

    {
      id: 10,
      description: 'Pend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      showCharCount: true,
      reviewScreenKey: 'pendCase',
      textAreaMaxLength: 2000,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLISTPEND',
          columnKey: 'noteType',
          left: '14%',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: '',
          name: 'Reason for Pend',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },
    {
      id: 11,
      description: 'UnPend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      showCharCount: true,
      reviewScreenKey: 'unpendCase',
      textAreaMaxLength: 999,
    },
  ];
}

export function getMasterCardActionPaneData() {
  return [
    {
      id: 1,
      width: '678px',
      title: 'Respond To Issuer:',
      seqNo: 0,
      description: 'Adjust Financials',
      viewCode: 'RTI',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 2,
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 100,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Acquirer Response',
          description: 'Acquirer Response',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Retrieval Request', 'Chargeback', 'Incoming Pre-Arbitration', 'Incoming Pre-Compliance'],//mastercard
        },
        {
          name: 'Response Reason',
          description: 'Response Reason',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback'],//mastercard
        },
        {
          name: 'Outgoing Message (required)',
          description: 'Outgoing Message (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          textAreaMaxLength: 100,
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance'],//mastercard
        },
        {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          textAreaMaxLength: 100,
          isRequired: false,
          stage: ['Retrieval Request', 'Chargeback'],//mastercard
        },

        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },
      ],
    },

    {
      id: 4,
      title: 'Respond To Issuer:',
      description: 'Merchant Message',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant','merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 6,
      title: 'Respond To Issuer:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to issuer',
          description: 'Send Documents to Issuer',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
    {
      id: 7,
      description: 'Close Case',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      nextStepPerformSubmit: false,
      textAreaMaxLength: 100,
      reviewScreenKey: 'closeCaseReason',
      disabled: true,
      dataColumns: [
        {
          description: 'Display',
          name: 'Display',
          displayType: 'DROPDOWN',
          columnKey: 'noteType',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: false,
        },
      ],
    },
    {
      id: 8,
      description: 'Add Case Notes',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      reviewScreenKey: 'addNote',
      showCharCount: true,
      textAreaMaxLength: 999,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '4%' : '5%',
          'margin-top': '49px',
          wrapperButtonStyle: {
            'margin-left': '348px',
            'margin-top': '-1',
          },
        },
        {
          description: 'Notes',
          name: 'Notes',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },

    {
      id: 10,
      description: 'Pend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      showCharCount: true,
      reviewScreenKey: 'pendCase',
      textAreaMaxLength: 2000,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLISTPEND',
          columnKey: 'noteType',
          left: '14%',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: '',
          name: 'Reason for Pend',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },
    {
      id: 11,
      description: 'UnPend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      showCharCount: true,
      reviewScreenKey: 'unpendCase',
      textAreaMaxLength: 999,
    },
  ];

}

export function getAmexActionPaneData() {
  return [
    {
      id: 1,
      width: '678px',
      title: 'Respond To Issuer:',
      seqNo: 0,
      description: 'Adjust Financials',
      viewCode: 'RTI',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 2,
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 437,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Acquirer Response',
          description: 'Acquirer Response',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          //   stage: ['Retrieval Request', 'Chargeback', 'Incoming Pre-Arbitration', 'Incoming Pre-Compliance'],//mastercard
        },
        {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: false,
          //  stage: ['Retrieval Request', 'Chargeback'],//mastercard
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },
      ],
    },

    {
      id: 4,
      title: 'Respond To Issuer:',
      description: 'Merchant Message',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 6,
      title: 'Respond To Issuer:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to issuer',
          description: 'Send Documents to Issuer',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}
export function getDiscoverCardBrandActionPaneData() {
  return [
    {
      id: 2,
      title: 'Respond To Card Brand:',
      viewCode: 'RTCB',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 700,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['cardBrand'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select Response to Arbitration Request',
          description: 'Select Response to Arbitration Request',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],
        },

        {
          name: 'Explanation to Card Brand',
          description: 'Explanation to Card Brand',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          stage: ['Incoming Arbitration'],
        },

        {
          name: 'Docs to Card Brand',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },

      ],
    },
    {
      id: 6,
      title: 'Respond To Card Brand:',
      description: 'Review Action',
      viewCode: 'RTCB',
      nextStepPerformSubmit: false,
      seqNo: 3,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',
              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Docs to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },
          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];

}
export function getMasterCardBrandActionPaneData() {
  return [
    {
      id: 2,
      title: 'Respond To Card Brand:',
      viewCode: 'RTCB',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 100,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['cardBrand'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Acquirer Response',
          description: 'Acquirer Response',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],
        },

        {
          name: 'Outgoing Message (Required)',
          description: 'Outgoing Message (Required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          textAreaMaxLength: 100,
          stage: ['Incoming Arbitration'],
        },

        {
          name: 'Docs to Card Brand',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
        },

      ],
    },
    {
      id: 6,
      title: 'Respond To Card Brand:',
      description: 'Review Action',
      viewCode: 'RTCB',
      nextStepPerformSubmit: false,
      seqNo: 3,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 100,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          textAreaMaxLength: 100,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',
              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Docs to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },
          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          textAreaMaxLength: 100,
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];

}

export function getEVOCardRIDActionPaneData() {
  return [
    {
      id: 46,
      title: 'Request Issuer Docs:',
      viewCode: 'RID',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 0,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 999,
      primaryButtonText: 'Submit',
      submitButtonText: 'Submit',      
      cancelButtonText: 'Cancel',
      disabled: true,
      dataColumns: [
        {
          name: 'Which documents are you requesting',
          description: 'Which documents are you requesting',
          displayType: 'DROPDOWN',
          width: isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Retrieval Request', 'Chargeback'],
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: isIE ? '200px' : '200px',
          left: isIE ? '11%' : '5%',
          bottom: '-37px',
          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          name: 'Notes',
          description: 'Notes',
          displayType: 'COMMENTS',
          width: isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: false,
          stage: ['Incoming Pre-Arbitration', 'Retrieval Request', 'Chargeback'],
        },

      ],
    },
  ];

}


export function getCardBrandAttachArray() {
  return [
    {
      id: 3,
      width: '678px',
      title: 'Respond To Card Brand:',
      description: 'Docs to Card Brand',
      viewCode: 'RTCB',
      nextStepPerformSubmit: false,
      seqNo: 2,
      reviewScreenKey: 'documentsToIssuer',
      attachType: 'cardBrand',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachBankImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },


  ];
}
export function getAttachArray() {
  return [   
   
    {
      id: 3,
      width: '678px',
      title: 'Respond To Issuer:',
      description: 'Send Documents to Issuer',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 2,
      reviewScreenKey: 'documentsToIssuer',
      attachType: 'issuer',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachBankImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 4,
      attachType: 'adjustFinancial',
      width: '678px',
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      description: 'Merchant Message',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
       dataColumns:[
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
              isAcceptance : true,
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },
      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 5,
      width: '678px',
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 4,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}

export function getUnableToDefendOrPursueData() {
  return [

    {
      id: 12,
      seqNo: 0,
      title: 'Unable to Defend/Pursue:',
      description: 'Merchant Message',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['adjustFinancial', 'merchant', 'merchant', 'liabilityInfo', 'liabilityInfo'],
      dataColumns: [

        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Merchant Accepts Liability',
          description: 'Merchant Accepts Liability',
          displayType: 'CHECKBOX',
        }
      ],

    },

    {
      id: 13,
      seqNo: 4,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      description: 'Review Action',
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'liabilityInfo',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'liabilityInfo',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },


        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];
}

export function getDefendOrPursueAttachArray() {
  return [

    {
      id: 14,
      seqNo: 2,
      title: 'Unable to Defend/Pursue:',
      description: 'Accept Liability',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 700,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Compliance', 'Incoming Compliance', 'Retrieval Request', 'Chargeback','Outgoing Goodfaith'],
        },
        {
          description: 'Select Response to Pre-arbitration Inquiry',
          name: 'Select Response to Pre-arbitration Inquiry',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration'],
        }, //US177338
        {
          description: 'Select Response to Arbitration Request',
          name: 'Select Response to Arbitration Request',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],
        }, //US177338
        {
          name: 'Outgoing Message',
          description: 'Outgoing Message',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Compliance', 'Incoming Compliance', 'Retrieval Request', 'Chargeback','Outgoing Goodfaith'],
          isRequired: true,
        },
        {
          name: 'Explanation to Issuer',
          description: 'Explanation to Issuer',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration'],
          isRequired: true,
        },//US177338
        {
          name: 'Explanation to Card Brand',
          description: 'Explanation to Card Brand',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Arbitration'],
          isRequired: true,
        }//US177338

      ]//US182168
    },
    {
      id: 15,
      width: '678px',
      seqNo: 3,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 16,
      width: '678px',
      seqNo: 1,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'adjustFinancial',
      description: 'Adjust Financials',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: 'Previous Step',
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
  ];
}

export function getMasterCardDefendOrPursueAttachArray() {
  return [

    {
      id: 14,
      seqNo: 2,
      title: 'Unable to Defend/Pursue:',
      description: 'Accept Liability',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 100,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Compliance', 'Incoming Pre-Arbitration', 'Incoming Arbitration', 'Incoming Compliance', 'Outgoing Compliance', 'Outgoing Goodfaith'],
        },
        //US177338
        {
          name: 'Outgoing Message (Required)',
          description: 'Outgoing Message (Required)',
          displayType: 'COMMENTS',
          textAreaMaxLength: 100,
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Compliance', 'Incoming Pre-Arbitration', 'Incoming Arbitration', 'Incoming Compliance','Outgoing Goodfaith'],
          isRequired: true,
        },


      ]//US182168
    },
    {
      id: 15,
      width: '678px',
      seqNo: 3,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 16,
      width: '678px',
      seqNo: 1,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'adjustFinancial',
      description: 'Adjust Financials',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: 'Previous Step',
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
  ];
}
export function getVisaDefendOrPursueAttachArray() {
  return [

    {
      id: 14,
      seqNo: 2,
      title: 'Unable to Defend/Pursue:',
      description: 'Accept Liability',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 700,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
        },
        {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback', 'Incoming Pre-Compliance', 'Incoming Compliance', 'Incoming Pre-Arbitration', 'Incoming Arbitration'],
          isRequired: false,
        }

      ]//US182168
    },
    {
      id: 15,
      width: '678px',
      seqNo: 3,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 16,
      width: '678px',
      seqNo: 1,
      title: 'Unable to Defend/Pursue:',
      viewCode: 'UTD',
      nextStepPerformSubmit: false,
      attachType: 'adjustFinancial',
      description: 'Adjust Financials',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: 'Previous Step',
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
  ];
}

export function getNotifyAndRequestDocs() {
  return [
    {
      id: 34,
      seqNo: 0,
      title: 'Notify & Request Documents:',
      viewCode: 'NRD',
      nextStepPerformSubmit: false,
      description: 'Merchant Message',
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['adjustFinancial', 'merchant', 'merchant'],
      dataColumns: [

        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 35,
      seqNo: 4,
      title: 'Notify & Request Documents:',
      viewCode: 'NRD',
      nextStepPerformSubmit: false,
      description: 'Review Action',
      submitButtonText: 'Send Notification',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'liabilityInfo',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'liabilityInfo',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];
}

export function getNotifyAndRequestDocsAttachArray() {
  return [
    {
      id: 36,
      width: '678px',
      seqNo: 2,
      viewCode: 'NRD',
      nextStepPerformSubmit: false,
      title: 'Notify & Request Documents:',
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 37,
      width: '678px',
      seqNo: 1,
      title: 'Notify & Request Documents:',
      viewCode: 'NRD',
      nextStepPerformSubmit: false,
      attachType: 'adjustFinancial',
      description: 'Adjust Financials',
      secondaryButtonText: 'Previous Step',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: 'Previous Step',
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },


  ];
}

export function getAdditionalInfoData() {
  return [
    {
      id: 17,
      title: 'Request Additional Information:',
      description: 'Merchant Message',
      viewCode: 'RAI',
      nextStepPerformSubmit: false,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['merchant', 'merchant','merchant','merchant'],
      dataColumns: [
        {
          description: 'Days Left Calendar',
          name: 'Deadline (optional)',
          displayType: 'DaysLeftCalendar',
          columnKey: 'DaysLeftCalendar',
          width: VITE_isIE ? '700px' : '680px',

        },
        { 
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Return to PDR If No Merchant Response Received',
          description: 'Return to PDR If No Merchant Response Received',
          displayType: 'CHECKBOX',
        },
        {
          description: 'MerchantMessage',
          id : 'ReasonforAdditionalReview',
          name: 'Reason for Additional Review',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '730px',
          isRequired: true,
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },

    {
      id: 18,
      title: 'Request Additional Information:',
      description: 'Review Action',
      viewCode: 'RAI',
      nextStepPerformSubmit: false,
      submitButtonText: 'Send Request',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },


        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];
}

export function getTakeActionCloseCaseData() {
  return [
    {
      id: 26,
      title: 'Close Case:',
      seqNo: 0,
      description: 'Reason for Closing',
      viewCode: 'CC',
      nextStepPerformSubmit: true,
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      primaryButtonText: 'Close Case',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['all', 'all'],
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '12%' : '9%',
          wrapperButtonStyle: {
            'margin-left': '70px',
            position: 'absolute',
            top: '59px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Explanation',
          name: 'Explanation',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
        },
         {
          name: 'Case Ruling',
          description: 'Record Case Ruling',
          displayType: 'CHECKBOX',
          stage: ['Incoming Arbitration'],
        },
      ],
    },

  ];
}

export function getTakeActionCloseCaseAttachArray() {
  return [
    {
      id: 26,
      title: 'Close Case:',
      seqNo: 0,
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      description: 'Reason for Closing',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      primaryButtonText: 'Next Step',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['all', 'all'],
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '12%' : '9%',
          wrapperButtonStyle: {
            'margin-left': '70px',
            position: 'absolute',
            top: '59px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Explanation',
          name: 'Explanation',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
        },
         {
          name: 'Case Ruling',
          description: 'Record Case Ruling',
          displayType: 'CHECKBOX',
          stage: ['Incoming Arbitration'],
        },
      ],
    },
    {
      id: 27,
      width: '678px',
      title: 'Close Case:',
      seqNo: 1,
      description: 'Adjust Financials',
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: 'Previous Step',
      ownerCheckboxIndex: 0,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },
      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 28,
      title: 'Close Case:',
      description: 'Merchant Message',
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      seqNo: 2,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['all'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
      ],

    },
    {
      id: 29,
      title: 'Close Case:',
      seqNo: 3,
      description: 'Review Action',
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      submitButtonText: 'Close Case',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Reason for Closing',
          description: 'Reason for Closing',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'closeCaseReason',
          columnKey: 'closeCaseReason',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',

          marginTop: '25px',
          wrapperButtonStyle: {
            'margin-left': '64px',
            'margin-top': '28px',
            position: 'absolute',
            bottom: '320px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];
}

export function getAdditionalInfoAttachArray() {
  return [

    {
      id: 19,
      width: '678px',
      title: 'Request Additional Information:',
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      viewCode: 'RAI',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}

export function getTakeActionCloseCasePinDebitAttachArray() {
  return [
    {
      id: 26,
      title: 'Close Case:',
      seqNo: 0,
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      description: 'Reason for Closing',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      primaryButtonText: 'Next Step',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      attachType: ['closeCaseReason','merchantMessage','reviewComment'],
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '12%' : '9%',
          wrapperButtonStyle: {
            'margin-left': '70px',
            position: 'absolute',
            top: '59px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Explanation',
          name: 'Explanation',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: true,
        },
      ],
    },
    {
      id: 28,
      title: 'Close Case:',
      description: 'Merchant Message',
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      seqNo: 2,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['all'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
      ],

    },
    {
      id: 29,
      title: 'Close Case:',
      seqNo: 3,
      description: 'Review Action',
      viewCode: 'CC',
      nextStepPerformSubmit: false,
      submitButtonText: 'Close Case',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Reason for Closing',
          description: 'Reason for Closing',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'closeCaseReason',
          columnKey: 'closeCaseReason',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',

          marginTop: '25px',
          wrapperButtonStyle: {
            'margin-left': '64px',
            'margin-top': '28px',
            position: 'absolute',
            bottom: '320px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];
}
export function getGoodWillData() {
  return [
    {
      id: 20,
      width: '678px',
      seqNo: 0,
      title: 'Write Off or Goodwill:',
      description: 'Adjust Financials',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      attachType: ['liabilityInfo'],
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'CHECKBOX',
          extraClass: 'marginTopCheckBox',
        },
      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },
    {
      id: 21,
      title: 'Write Off or Goodwill:',
      seqNo: 1,
      description: 'Write Off Reason',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 500,
      reviewScreenKey: 'writeOffReason',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Explanation',
          description: 'Explanation',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback','Outgoing Arbitration','Outgoing Pre-Arbitration','Outgoing Compliance','Chargeback Reversal','Incoming Goodfaith','Outgoing Pre-Compliance','Outgoing Goodfaith','Arbitration Chargeback','Second Chargeback'],/**Added 'Outgoing Arbitration','Outgoing Pre-Arbitration','Outgoing Compliance''Incoming Goodfaith','Outgoing Pre-Compliance','Outgoing Goodfaith','Outgoing Pre-Arbitration','Arbitration Chargeback','Outgoing Arbitration for #421 */

         isRequired: true,
        },
      ],
    },
    {
      id: 22,
      title: 'Write Off or Goodwill:',
      description: 'Merchant Message',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      seqNo: 2,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },


    {
      id: 23,
      title: 'Write Off or Goodwill:',
      seqNo: 5,
      description: 'Review Action',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      submitButtonText: 'Submit',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          name: 'Write Off Reason',
          description: 'Write Off Reason',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'writeOffReason',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'writeOffReason',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'liabilityInfo',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'liabilityInfo',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
  ];
}

export function getGoodWillAttachArray() {
  return [

    {
      id: 24,
      title: 'Write Off or Goodwill:',
      description: 'Accept Liability',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      seqNo: 4,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 700,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
        },
        {
          name: 'Outgoing Message',
          description: 'Outgoing Message',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback','Chargeback Reversal'],
          isRequired: true,
        }

      ],
    },
    {
      id: 25,
      width: '678px',
      title: 'Write Off or Goodwill:',
      seqNo: 3,
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}
export function getMasterCardGoodWillAttachArray() {
  return [

    {
      id: 24,
      title: 'Write Off or Goodwill:',
      description: 'Accept Liability',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      seqNo: 4,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 100,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance','Chargeback Reversal','Outgoing Compliance','Outgoing Pre-Compliance', 'Outgoing Goodfaith'],
        },
        {
          name: 'Outgoing Message (Required)',
          description: 'Outgoing Message (Required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          textAreaMaxLength: 100,
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Chargeback Reversal', 'Outgoing Pre-Compliance', 'Outgoing Goodfaith'],
          isRequired: true,
        }

      ],
    },
    {
      id: 25,
      width: '678px',
      title: 'Write Off or Goodwill:',
      seqNo: 3,
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}

export function getVisaGoodWillAttachArray() {
  return [

    {
      id: 24,
      title: 'Write Off or Goodwill:',
      description: 'Accept Liability',
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      seqNo: 4,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 700,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
        },
        {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback', 'Incoming Pre-Compliance', 'Incoming Compliance', 'Incoming Pre-Arbitration', 'Incoming Arbitration','Chargeback Reversal'],
          isRequired: false,
        }

      ],
    },
    {
      id: 25,
      width: '678px',
      title: 'Write Off or Goodwill:',
      seqNo: 3,
      viewCode: 'WOG',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}
export function getTakeActionTransferCaseData() {
  return [
    {
      id: 38,
      description: 'Transfer Case',
      seqNo: 0,
      viewCode: 'TC',
      info: '',
      showCharCount: true,
      textAreaMaxLength: 2000,
      reviewScreenKey: 'transferCase',
      primaryButtonText: 'Transfer',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Purpose of Transfer',
          name: 'Purpose of Transfer',
          selectInputLabel: 'Purpose of Transfer',
          searchDropdownLabel: 'Transfer To',
          displayType: 'AUTOCOMPLETEDROPDOWNCOMBO',
          columnKey: 'transferPurpose',
          width: VITE_isIE ? '315px' : '300px',
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'transferComments',
          width: VITE_isIE ? '700px' : '678px',
          isRequired: false,
        },

      ],
    },

  ];
}

export function getVisaActionPaneData() {
  return [
    {
      id: 1,
      width: '678px',
      title: 'Respond To Issuer:',
      seqNo: 0,
      description: 'Adjust Financials',
      viewCode: 'RTI',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },    
    {
      id: 2,
      title: 'Respond To Issuer:',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 700,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'QUESTIONNAIRE',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Chargeback'],
        },
        {
          name: 'Acquirer Response',
          description: ' Acquirer Response',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request'],//US182163,US182161
        },
        {
          name: 'Acceptance Amount',
          description: 'Acceptance Amount',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '350px' : '325px',
          marginTop: '20px',
          marginLeft: '0px',
          disabled: false,
          isOptional: false,
          isCurrencyLabel: true,
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance'],
        },
        {
          name: 'Transfer Funds Now',
          description: 'Transfer Funds Now?',
          displayType: 'RADIO_BUTTON',
          width: VITE_isIE ? '350px' : '325px',
          isOptional: true,
          stage: ['Incoming Pre-Compliance'],
        },
        {
          name: 'Why are you not accepting liability ?',
          description: 'Why are you not accepting liability ?',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance'],//US182163
        }, {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: false,
          stage: ['Retrieval Request'],//US182161
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182161
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request']
        },
       
      ],
    },

    {
      id: 4,
      title: 'Respond To Issuer:',
      description: 'Merchant Message',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 3,
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      attachType: ['merchant', 'merchant', 'adjustFinancial'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          isOptionalCheckbox: true,
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance'],
        },
      ],

    },
    {
      id: 6,
      title: 'Respond To Issuer:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
          {
            name: 'Financial Adjustments',
            description: 'Financial Adjustment',
            displayType: 'ReviewScreen',
            reviewScreenKey: 'financialAdjustment',
            contentType: 'ATTACH_IMAGE',
            columnKey: 'financialAdjustment',
            width: VITE_isIE ? '750px' : '746px',
            editButtonId: 0,
            config:
            {
              displayType: 'Table',
              columns: [
                {
                  columnId: 1,
                  displayOrder: 1,
                  isDefault: true,
                  jsonKey: 'ledger',
                  label: 'Ledger',
                  type: 'string',
                },
                {
                  columnId: 2,
                  displayOrder: 2,
                  isDefault: true,
                  jsonKey: 'debit',
                  label: 'Debit (USD)',
                  type: 'string',
                },
                {
                  columnId: 3,
                  displayOrder: 3,
                  isDefault: true,
                  jsonKey: 'credit',
                  label: 'Credit (USD)',
                  type: 'string',
                },
                {
                  columnId: 4,
                  displayOrder: 4,
                  isDefault: true,
                  jsonKey: 'internalNote',
                  label: 'Internal Note',
                  type: 'string',
                },
              ],
            },
          },
        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to issuer',
          description: 'Send Documents to Issuer',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },
    {
      id: 7,
      description: 'Close Case',
      info: 'When closing the case, no outgoing files, no ledger updates, and no correspondence is generated. Please ensure proper comments are entered for audit purposes.',
      showCharCount: true,
      nextStepPerformSubmit: false,
      textAreaMaxLength: 999,
      reviewScreenKey: 'closeCaseReason',
      disabled: true,
      dataColumns: [
        {
          description: 'Display',
          name: 'Display',
          displayType: 'DROPDOWN',
          columnKey: 'noteType',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'closeCaseComment',
          width: VITE_isIE ? '700px' : '678px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: false,
        },
      ],
    },
    {
      id: 8,
      description: 'Add Case Notes',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      reviewScreenKey: 'addNote',
      showCharCount: true,
      textAreaMaxLength: 999,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '4%' : '5%',
          'margin-top': '49px',
          wrapperButtonStyle: {
            'margin-left': '348px',
            'margin-top': '-1',
          },
        },
        {
          description: 'Notes',
          name: 'Notes',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: true,
        },
      ],
    },

    {
      id: 10,
      description: 'Pend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      nextStepPerformSubmit: false,
      showCharCount: true,
      reviewScreenKey: 'pendCase',
      textAreaMaxLength: 2000,
      dataColumns: [
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLISTPEND',
          columnKey: 'noteType',
          left: '14%',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: '',
          name: 'Reason for Pend',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '678px',
        },
      ],
    },
    {
      id: 11,
      description: 'UnPend Case',
      width: VITE_isIE ? '700px' : '678px',
      disabled: true,
      showCharCount: true,
      reviewScreenKey: 'unpendCase',
      textAreaMaxLength: 999,
    },
  ];
}
export function getUnableToFullfillData() {
  return [
    {
      id: 39,
      width: '725px',
      seqNo: 0,
      title: 'Unable to Fulfill:',
      description: 'Merchant Message',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'merchantMessage',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      attachType: ['liabilityInfo', 'merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],
    },

    {
      id: 42,
      seqNo: 3,
      title: 'Unable to Fulfill:',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      description: 'Review Action',
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'liabilityInfo',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'liabilityInfo',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        }
      ],
    },
  ]

}
export function getProsaUnableToFullfillData() {
  return [
    {
      id: 39,
      width: '725px',
      seqNo: 0,
      title: 'Unable to Fulfill:',
      description: 'Merchant Message',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'merchantMessage',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      attachType: ['merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],
    },
    {
      id: 42,
      seqNo: 3,
      title: 'Unable to Fulfill:',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      description: 'Review Action',
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },
          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        }
      ],
    },
  ]
}
export function getAmexUnableToFullfillData() {
  return [
    {
      id: 39,
      width: '725px',
      seqNo: 0,
      title: 'Unable to Fulfill:',
      description: 'Merchant Message',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      reviewScreenKey: 'merchantMessage',
      primaryButtonText: 'Next Step',
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      attachType: ['liabilityInfo', 'merchant', 'merchant'],
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],
    },

    {
      id: 42,
      seqNo: 3,
      title: 'Unable to Fulfill:',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      description: 'Review Action',
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
        },

        {
          name: 'Accept Liability',
          description: 'Accept Liability',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'liabilityInfo',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'liabilityInfo',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        }
      ],
    },
  ]

}


export function getUnableToFulfillAttachArray() {
  return [
    {
      id: 40,
      title: 'Unable to Fulfill:',
      description: 'Accept Liability',
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      seqNo: 1,
      width: '725px',
      showCharCount: false,
      textAreaMaxLength: 700,
      reviewScreenKey: 'liabilityInfo',
      attachType: 'liabilityInfo',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Acquirer Response',
          name: 'Acquirer Response',
          displayType: 'DROPDOWN',
          columnKey: 'acquirerResponse',
          width: VITE_isIE ? '700px' : '725px',
          disabled: true,
        },
        {
          name: 'Outgoing Message (optional)',
          description: 'Outgoing Message (optional)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          stage: ['Incoming Pre-Arbitration', 'Incoming Pre-Compliance', 'Incoming Arbitration', 'Incoming Compliance', 'Retrieval Request', 'Chargeback'],
          isRequired: false,
        },

      ],
    },
    {
      id: 41,
      width: '725px',
      title: 'Unable to Fulfill:',
      seqNo: 2,
      viewCode: 'UTF',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

  ];
}

export function getEvoCardPCFActionPaneData() {
  return [

    {
      id: 2,
      title: 'Pursue Case Filing:',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 100,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer', 'adjustFinancial', 'merchantAdvice'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select and Create Case Filing Type (required)',
          description: 'Select and Create Case Filing Type (required)',
          displayType: 'DROPDOWN',
          width: isIE ? '700px' : '725px',
          resetDataList:[...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__],
        },
        {
          name: 'Case Amount (required)',
          description: 'Case Amount (required)',
          displayType: 'CURRENCY',
          width: isIE ? '250px' : '225px',
          marginTop: '20px',
          disabled: true,
          marginLeft: '0px',
          sameLine: true,
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__],
        },
        {
          name: 'Filing Amount (required)',
          description: 'Filing Amount (required)',
          displayType: 'CURRENCY',
          width: isIE ? '250px' : '225px',
          marginTop: '-81px',
          marginLeft: '250px',
          isRequired: true,
          currencyCodeDisabled: true,
          isMerchantCurrencyCode: true,
          sameLine: true,
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__],
        },
        {
          name: 'Good Faith Type (required)',
          description: 'Good Faith Type (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: isIE ? '700px' : '725px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Response Date (required)',
          description: 'Good Faith Response Date (required)',
          displayType: 'DATE',
          width: isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '20px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Amount (required)',
          description: 'Good Faith Amount (required)',
          displayType: 'CURRENCY',
          width: isIE ? '250px' : '225px',
          marginTop: '20px',
          marginLeft: '0px',
          isRequired: true,
          currencyCodeDisabled: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
          max: 19,
          validate: (value) => decimalNumber(value, 18),
        },
        {
          name: 'Reason For Good Faith (required)',
          description: 'Reason For Good Faith (required)',
          displayType: 'COMMENTS',
          width: isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Reason For Filing (required)',
          description: 'Reason For Filing (required)',
          displayType: 'COMMENTS',
          width: isIE ? '700px' : '725px',
          marginTop: '20px',
          textAreaMaxLength: 100,
          isRequired: true,
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__],
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__],
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__,...__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__],
        },
        {
          name: 'Merchant Advice',
          description: 'Merchant Message',
          displayType: 'CHECKBOX',
          selectedItem: [...__FILE_INCOMING_ARBITRATION_STAGE_CONFIG__,...__FILE_OUTGOING_ARBITRATION_STAGE_CONFIG__,...__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__],
        },


      ],
    },


    {
      id: 6,
      title: 'Pursue Case Filing:',
      description: 'Review Action',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      seqNo: 6,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 100,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: isIE ? '750px' : '746px',
          editButtonId: 1,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: isIE ? '750px' : '746px',
          editButtonId: 4,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: isIE ? '200px' : '200px',
          left: isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          textAreaMaxLength: 100,
          width: isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}

export function getMasterCardPCFActionPaneData() {
  return [

    {
      id: 2,
      title: 'Pursue Case Filing:',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 100,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer', 'adjustFinancial', 'merchantAdvice'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select and Create Case Filing Type (required)',
          description: 'Select and Create Case Filing Type (required)',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          resetDataList: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Case Amount (required)',
          description: 'Case Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          disabled: true,
          marginLeft: '0px',
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Filing Amount (required)',
          description: 'Filing Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '-81px',
          marginLeft: '250px',
          isRequired: true,
          currencyCodeDisabled: true,
          isMerchantCurrencyCode: true,
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Date Of Violation (required)',
          description: 'Date Of Violation (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          isRequired: true,
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Date Of Discovery (required)',
          description: 'Date Of Discovery (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '-79px',
          marginLeft: '250px',
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__)
        },
        {
          id: 'primRuleViolatedPCF',
          name: 'Primary Rule Violated (required)',
          description: 'Primary Rule Violated (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: VITE_isIE ? '700px' : '725px',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__)
        },
        {
          id: 'creditDatePCF',
          name: 'Credit Date (required)',
          description: 'Credit Date (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '25px',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
          bindWithValue: '1.4',
        },
        {
          name: 'Good Faith Type (required)',
          description: 'Good Faith Type (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: VITE_isIE ? '700px' : '725px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Response Date (required)',
          description: 'Good Faith Response Date (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '20px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Amount (required)',
          description: 'Good Faith Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          marginLeft: '0px',
          isRequired: true,
          currencyCodeDisabled: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
          max: 19,
          validate: (value) => decimalNumber(value, 18),
        },
        {
          name: 'Financial Loss Occured',
          description: 'Financial Loss Occured',
          displayType: 'MSGBOX',
          textAreaMaxLength: 100,
          marginTop: '20px',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Reason For Good Faith (required)',
          description: 'Reason For Good Faith (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Reason For Filing (required)',
          description: 'Reason For Filing (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          textAreaMaxLength: 100,
          isRequired: true,
          selectedItem: __FILE_COMPLIANCE_STAGE_CONFIG__,
        },
        {
          name: 'Reason for Initiating Pre-compliance (required)',
          description: 'Reason for Initiating Pre-compliance (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          textAreaMaxLength: 100,
          isRequired: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__,
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Merchant Advice',
          description: 'Merchant Message',
          displayType: 'CHECKBOX',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },


      ],
    },


    {
      id: 6,
      title: 'Pursue Case Filing:',
      description: 'Review Action',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      seqNo: 6,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 100,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          textAreaMaxLength: 100,
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}

export function getProsaCardPCFActionPaneData() {
  return [

    {
      id: 2,
      title: 'Pursue Case Filing:',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 1000,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer', 'adjustFinancial', 'merchantAdvice'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select and Create Case Filing Type (required)',
          description: 'Select and Create Case Filing Type (required)',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          resetDataList: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__).concat(__OTHER_VIOLATION_CODE__),
        },
        {
          name: 'Case Amount (required)',
          description: 'Case Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          disabled: true,
          marginLeft: '0px',
          sameLine: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Filing Amount (required)',
          description: 'Filing Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '-81px',
          marginLeft: '250px',
          isRequired: true,
          sameLine: true,
          isMerchantCurrencyCode: true,
          currencyCodeDisabled: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Reason For Filing (required)',
          description: 'Reason For Filing (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__)
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Merchant Advice',
          description: 'Merchant Message',
          displayType: 'CHECKBOX',
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },


      ],
    },


    {
      id: 6,
      title: 'Pursue Case Filing:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 6,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}

export function getGoodFaithPCFActionPaneData() {
  return [

    {
      id: 2,
      title: 'Pursue Case Filing:',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 1000,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['adjustFinancial', 'merchantAdvice', 'merchant'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select and Create Case Filing Type (required)',
          description: 'Select and Create Case Filing Type (required)',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          resetDataList: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Good Faith Type (required)',
          description: 'Good Faith Type (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: VITE_isIE ? '700px' : '725px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Good Faith Response Date (required)',
          description: 'Good Faith Response Date (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '20px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Good Faith Amount (required)',
          description: 'Good Faith Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          marginLeft: '0px',
          isRequired: true,
          currencyCodeDisabled: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
          max: 19,
          validate: (value) => decimalNumber(value, 18),
        },

        {
          name: 'Reason For Good Faith (required)',
          description: 'Reason For Good Faith (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Merchant Advice',
          description: 'Merchant Message',
          displayType: 'CHECKBOX',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__.concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },


      ],
    },


    {
      id: 6,
      title: 'Pursue Case Filing:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 5,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },

        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}


const __OTHER_VIOLATION_CODE__ = ["other"];
export function getVisaCardPCFActionPaneData() {
  return [

    {
      id: 2,
      title: 'Pursue Case Filing:',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      description: 'Questionnaire',
      seqNo: 1,
      width: '725px',
      showCharCount: true,
      textAreaMaxLength: 1000,
      reviewScreenKey: 'representmentQuestion',
      attachType: ['issuer', 'adjustFinancial', 'merchantAdvice'],
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: 'Select and Create Case Filing Type (required)',
          description: 'Select and Create Case Filing Type (required)',
          displayType: 'DROPDOWN',
          width: VITE_isIE ? '700px' : '725px',
          resetDataList: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__).concat(__OTHER_VIOLATION_CODE__),
        },
        {
          name: 'Case Amount (required)',
          description: 'Case Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          disabled: true,
          marginLeft: '0px',
          sameLine: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Filing Amount (required)',
          description: 'Filing Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '-81px',
          marginLeft: '250px',
          isRequired: true,
          sameLine: true,
          isMerchantCurrencyCode: true,
          currencyCodeDisabled: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },


        {
          name: 'Date Of Violation (required)',
          description: 'Date Of Violation (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          isRequired: true,
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Date Of Discovery (required)',
          description: 'Date Of Discovery (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '-79px',
          marginLeft: '250px',
          sameLine: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Primary Rule Violated (required)',
          description: 'Primary Rule Violated (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: VITE_isIE ? '700px' : '725px',
          resetDataList: ["C050"],
          resetDataColumnNames: ["Additional Information on Rules Violated (required)"],
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Additional Information on Rules Violated (required)',
          description: 'Additional Information on Rules Violated (required)',
          displayType: 'TEXT',
          width: VITE_isIE ? '350px' : '325px',
          marginTop: '20px',
          marginLeft: '0px',
          isRequired: true,
          selectedItem: __OTHER_VIOLATION_CODE__,
        },
        {
          name: 'Good Faith Type (required)',
          description: 'Good Faith Type (required)',
          displayType: 'DROPDOWN',
          isRequired: true,
          marginTop: '20px',
          width: VITE_isIE ? '700px' : '725px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Response Date (required)',
          description: 'Good Faith Response Date (required)',
          displayType: 'DATE',
          width: VITE_isIE ? '250px' : '225px',
          isRequired: true,
          marginTop: '20px',
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Good Faith Amount (required)',
          description: 'Good Faith Amount (required)',
          displayType: 'CURRENCY',
          width: VITE_isIE ? '250px' : '225px',
          marginTop: '20px',
          marginLeft: '0px',
          isRequired: true,
          currencyCodeDisabled: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
          max: 19,
          validate: (value) => decimalNumber(value, 18),
        },
        {
          id: 'isfinancialLoss',
          name: 'Financial Loss Occured',
          description: 'Financial Loss Occured',
          displayType: 'MSGBOX',
          marginTop: '20px',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
          bindWithValue: 'C135',
        },
        {
          id: 'financialLossExp',
          name: 'Financial Loss Explaination (required)',
          description: 'Financial Loss Explaination (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
          bindWithValue: 'C135',
          isRequired: true,
        },
        {
          name: 'Reason For Good Faith (required)',
          description: 'Reason For Good Faith (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__,
        },
        {
          name: 'Reason For Filing (required)',
          description: 'Reason For Filing (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__FILE_COMPLIANCE_STAGE_CONFIG__)
        },
        {
          name: 'Reason for Initiating Pre-compliance (required)',
          description: 'Reason for Initiating Pre-compliance (required)',
          displayType: 'COMMENTS',
          width: VITE_isIE ? '700px' : '725px',
          marginTop: '20px',
          isRequired: true,
          selectedItem: __INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__,
        },
        {
          name: 'Send Documents to Issuer',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',//US182222
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__),
        },
        {
          name: 'Adjust Financials',
          description: 'Make Financial Adjustments',
          displayType: 'CHECKBOX',
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },
        {
          name: 'Merchant Advice',
          description: 'Merchant Message',
          displayType: 'CHECKBOX',
          selectedItem: __FILE_ARBITRATION_STAGE_CONFIG__.concat(__INITIATE_PRE_COMPLIANCE_STAGE_CONFIG__).concat(__FILE_COMPLIANCE_STAGE_CONFIG__).concat(__CREATE_GOOD_FAITH_REQUEST_STAGE_CONFIG__),
        },


      ],
    },


    {
      id: 6,
      title: 'Pursue Case Filing:',
      description: 'Review Action',
      viewCode: 'RTI',
      nextStepPerformSubmit: false,
      seqNo: 6,
      submitButtonText: 'Submit Response',
      reviewScreenKey: 'reviewComment',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      textAreaMaxLength: 999,
      dataColumns: [

        {
          name: 'Questionnaire',
          description: 'Questionnaire',
          displayType: 'ReviewScreen',
          contentType: 'ATTACH_IMAGE',
          reviewScreenKey: 'representmentQuestion',
          columnKey: 'representmentQuestion',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 0,
          config:
          {
            displayType: 'InputDescription',
            columns:
            {
              Description: 'Description',

              OBT: 'Outgoing Bank Text',
            },
          },
        },
        {
          name: 'Documents to Card Brand',
          description: 'Docs to Card Brand',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToIssuer',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToIssuer',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 1,
        },
        {
          name: 'Merchant Message',
          description: 'Merchant Message',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'merchantMessage',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 2,
        },
        {
          name: 'Documents to Merchant',
          description: 'Send Documents to Merchant',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'documentsToMerchant',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'documentsToMerchant',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 3,
        },
        {
          name: 'Financial Adjustments',
          description: 'Financial Adjustment',
          displayType: 'ReviewScreen',
          reviewScreenKey: 'financialAdjustment',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'financialAdjustment',
          width: VITE_isIE ? '750px' : '746px',
          editButtonId: 4,
          config:
          {
            displayType: 'Table',
            columns: [
              {
                columnId: 1,
                displayOrder: 1,
                isDefault: true,
                jsonKey: 'ledger',
                label: 'Ledger',
                type: 'string',
              },
              {
                columnId: 2,
                displayOrder: 2,
                isDefault: true,
                jsonKey: 'debit',
                label: 'Debit (USD)',
                type: 'string',
              },
              {
                columnId: 3,
                displayOrder: 3,
                isDefault: true,
                jsonKey: 'credit',
                label: 'Credit (USD)',
                type: 'string',
              },
              {
                columnId: 4,
                displayOrder: 4,
                isDefault: true,
                jsonKey: 'internalNote',
                label: 'Internal Note',
                type: 'string',
              },
            ],
          },
        },
        {
          description: '',
          name: '',
          displayType: 'DROPDOWNLIST',
          columnKey: 'noteType',
          width: VITE_isIE ? '200px' : '200px',
          left: VITE_isIE ? '11%' : '8%',
          marginTop: '24px',
          wrapperButtonStyle: {
            'margin-left': '64px',
          },

          dropDownList: [
            {
              value: false,
              text: 'Internal',
            },
            {
              value: true,
              text: 'External',
            },
          ],
        },
        {
          description: 'Comments',
          name: 'Comments',
          displayType: 'COMMENTS',
          columnKey: 'noteComment',
          width: VITE_isIE ? '700px' : '745px',
          isRequired: false,
        },
      ],
    },

  ];

}
export function getPCFAttachArray() {
  return [
    {
      id: 3,
      width: '678px',
      title: 'Pursue Case Filing:',
      description: 'Send Documents to Card Brand',
      name: 'Send Documents to Card Brand',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      seqNo: 2,
      reviewScreenKey: 'documentsToIssuer',
      attachType: 'issuer',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachBankImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },

    {
      id: 4,
      title: 'Pursue Case Filing:',
      description: 'Merchant Message',
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      seqNo: 3,
      attachType: 'merchantAdvice',
      secondaryAttachType: ['merchant', 'merchant'],
      primaryButtonText: 'Next Step',
      reviewScreenKey: 'merchantMessage',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          description: 'Merchant Message',
          name: 'Merchant Message',
          displayType: 'MerchantMessage',
          columnKey: 'merchantMessage',
          width: VITE_isIE ? '700px' : '678px',
        },
        {
          name: 'Send Letter to Merchant',
          description: 'Prevent Merchant Notification',
          displayType: 'CHECKBOX',
        },
        {
          name: 'Send Documents to Merchant',
          description: 'Attach Documents',
          displayType: 'CHECKBOX',
        },
      ],

    },
    {
      id: 5,
      width: '725px',
      title: 'Pursue Case Filing:',
      seqNo: 4,
      viewCode: 'PCF',
      nextStepPerformSubmit: false,
      attachType: 'merchant',
      description: 'Send Documents to Merchant',
      reviewScreenKey: 'documentsToMerchant',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      dataColumns: [
        {
          name: '',
          description: '',
          displayType: 'WIZARD_ACCORDIAN',
          contentType: 'ATTACH_IMAGE',
          columnKey: 'attachMerchantImage',
          width: VITE_isIE ? '750px' : '746px',
        },
      ],
    },
    {
      id: 1,
      width: '678px',
      title: 'Pursue Case Filing:',
      seqNo: 5,
      description: 'Adjust Financials',
      viewCode: 'PCF',
      attachType: 'adjustFinancial',
      reviewScreenKey: 'financialAdjustment',
      primaryButtonText: 'Next Step',
      secondaryButtonText: 'Previous Step',
      cancelButtonText: 'Cancel',
      nextStepPerformSubmit: false,
      dataColumns: [
        {
          displayType: 'DisplayPanel',
          structure: [
            {
              name: 'Merchant Settlement Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantSettlementAmount',
            },
            {
              name: 'Partial Chargeback Indicator',
              displayType: 'INDICATOR',
              columnKey: 'partialChargebackIndicator',
            },
            {
              name: 'Merchant Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'merchantAdjustmentAmount',
            }, {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            }, {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            }, {
              name: 'Issuer Adjust Amount',
              displayType: 'CURRENCY',
              columnKey: 'issuerAdjustmentAmount',
            },
          ],
          size: '80%',
          identifier: 'financialData',
        },
        {
          displayType: 'DisplayPanel',
          customClass: 'large-amount',
          structure: [
            {
              name: 'Case Amount',
              displayType: 'CURRENCY',
              columnKey: 'caseAmount',
            },
            {
              name: 'Balance',
              displayType: 'BALANCE_AMOUNT',
              columnKey: 'balanceAmount',
            },
          ],
          size: '15%',
          identifier: 'financialData',
        },
        {
          title: 'Ledger',
          displayType: 'NestedFieldSelector',
          size: 12,
          inputList: [
            {
              id: 'v1',
              label: 'Debit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v2',
            },
            {
              id: 'v2',
              label: 'Credit',
              postLabelKey: 'caseAmountCurrency',
              inputType: 'number',
              disableWhenId: 'v1',
            },
            {
              id: 'v3',
              label: 'Internal Notes',
              inputType: 'text',
            },
          ],
          identifier: 'ledgers',
          bindWith: 'financialData',
        },

      ],
      smallBoxDataColumns: [
        {
          description: 'Case Amount',
          name: 'Case Amount',
          displayType: 'STRING',
          columnKey: '',
          width: VITE_isIE ? '200px' : '200px',
        },
        {
          description: 'Balance',
          name: 'Balance',
          displayType: 'BALANCE',
          width: VITE_isIE ? '200px' : '200px',
        },
      ],
    },


  ];
}
export function getTranslations() {
  return {
    applyFilterPane: 'Search',
    nextStep: 'Next Step',
    submit: 'Submit',
    closeCase: 'Close Case',
    cancel: 'Cancel',
    transfer: 'Transfer',
    clearFilterPane: 'Clear All Fields',
    less: 'Less',
    more: 'More',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
  };
}


export function getUploadDocumentData() {
  return [

    {
      id: 101,
      title: '',
      description: 'Upload Document',
      viewCode: 'UD',
      info: `You can drag your document into the panel to the right, or click the Browse button to find it on your computer.`,
      nextStepPerformSubmit: false,
      seqNo: 0,
      width: '725px',
      showCharCount: false,
      reviewScreenKey: 'uploadDocument',
      attachType: 'uploadDocument',
      primaryButtonText: 'Submit',
      secondaryButtonText: '',
      cancelButtonText: 'Cancel',

      dataColumns: [
        {
          name: 'Upload Documents',
          description: 'Upload Documents',
          displayType: 'UPLOAD_DOCUMENT',
          width: VITE_isIE ? '700px' : '725px',
        },

      ],
    },
  ];
}
